// Linked Banner (Vision) - JS STRICT
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.linked-banner__img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  });
})();
